import { render, staticRenderFns } from "./formSlider.vue?vue&type=template&id=008f9f1f&scoped=true"
import script from "./formSlider.vue?vue&type=script&lang=js"
export * from "./formSlider.vue?vue&type=script&lang=js"
import style0 from "./formSlider.vue?vue&type=style&index=0&id=008f9f1f&prod&lang=css"
import style1 from "./formSlider.vue?vue&type=style&index=1&id=008f9f1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008f9f1f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VContainer,VFileInput,VRow,VSelect,VTextField,VTextarea})
